import PropTypes from 'prop-types';
import SectionDivider from 'modules/common/components/SectionDivider/SectionDivider';
import { formValidationErrorType, statusList } from 'modules/common/enums';
import { useSelector } from 'react-redux';
import DropdownMenu from '../../../common/components/DropdownMenu';
import masterServicesStrings from '../../strings';
import {
  FormFieldWrapper,
  FormGrid,
  FormLabel,
  FormTextInput,
  FormValidationError,
} from './AddOrEditMasterServiceComponent.style';

// ###############################################################
// <------------------------ Constants -------------------------->
// ###############################################################
// ###############################################################
// <---------------------- End Constants ------------------------>
// ###############################################################
const AddOrEditMasterServiceComponent = ({
  formFieldsValues,
  setFormFieldsValues,
  formFieldsValidation,
}) => {
  // ###############################################################
  // <------------------------- Globals --------------------------->
  // ###############################################################
  const categories = useSelector(state => state.masterServices.categories.details);
  // ###############################################################
  // <----------------------- End Globals ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useState --------------------------->
  // ###############################################################
  // ###############################################################
  // <---------------------- End useState ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useEffect -------------------------->
  // ###############################################################
  // ###############################################################
  // <---------------------- End useEffect ------------------------>
  // ###############################################################
  // ###############################################################
  // <--------------------- rest of hooks ------------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------- End rest of hooks ---------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Logic ---------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Logic -------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Actions --------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- End Actions ------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- UI Handlers ------------------------->
  // ###############################################################
  const handleTextInputFieldChange = (fieldName, fieldEvent) => {
    const { value } = fieldEvent.target;
    setFormFieldsValues(prevValue => {
      const fieldsObj = { ...prevValue };
      fieldsObj[fieldName] = value;
      return fieldsObj;
    });
  };

  const handleDropDownFieldChange = selectedObj => {
    setFormFieldsValues(prevValue => {
      const fieldsObj = { ...prevValue };
      fieldsObj.status = selectedObj.key;
      return fieldsObj;
    });
  };
  // ###############################################################
  // <--------------------- End UI Handlers ----------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Render --------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Render ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Return UI ------------------------->
  // ###############################################################
  return (
    <FormGrid>
      <FormFieldWrapper>
        <FormLabel>
          {masterServicesStrings.masterServiceDetailsContent.englishNameFieldLabel}*
        </FormLabel>
        <SectionDivider gap={8} />
        <FormTextInput
          type="text"
          value={formFieldsValues.englishName}
          onChange={event => handleTextInputFieldChange('englishName', event)}
        />
        {formFieldsValidation.englishName === formValidationErrorType.empty && (
          <>
            <SectionDivider gap={4} />
            <FormValidationError>
              {masterServicesStrings.masterServiceDetailsContent.formFieldErrorText(
                masterServicesStrings.masterServiceDetailsContent.englishNameFieldLabel,
              )}
            </FormValidationError>
          </>
        )}
      </FormFieldWrapper>
      <FormFieldWrapper>
        <FormLabel>
          {masterServicesStrings.masterServiceDetailsContent.arabicNameFieldLabel}*
        </FormLabel>
        <SectionDivider gap={8} />
        <FormTextInput
          type="text"
          dir="rtl"
          value={formFieldsValues.arabicName}
          onChange={event => handleTextInputFieldChange('arabicName', event)}
        />
        {formFieldsValidation.arabicName === formValidationErrorType.empty && (
          <>
            <SectionDivider gap={4} />
            <FormValidationError>
              {masterServicesStrings.masterServiceDetailsContent.formFieldErrorText(
                masterServicesStrings.masterServiceDetailsContent.arabicNameFieldLabel,
              )}
            </FormValidationError>
          </>
        )}
      </FormFieldWrapper>
      <FormFieldWrapper span={2}>
        <FormLabel>
          {masterServicesStrings.masterServiceDetailsContent.categoryFieldLabel}
        </FormLabel>
        <SectionDivider gap={8} />
        <FormTextInput
          type="text"
          value={
            categories?.length > 0 &&
            categories.find(category => category.categoryKey === formFieldsValues.categoryKey)
              ?.categoryNameEn
          }
          disabled
        />
      </FormFieldWrapper>
      <FormFieldWrapper span={2}>
        <FormLabel>{masterServicesStrings.masterServiceDetailsContent.statusFieldLabel}*</FormLabel>
        <DropdownMenu
          dropdownMenuItemsList={statusList}
          dropdownMenuSelectedObj={statusList.find(type => type.value === formFieldsValues.status)}
          handleDropdownMenuChange={handleDropDownFieldChange}
          objectMapper={{ key: 'value', name: 'name' }}
        />
        {formFieldsValidation.status === formValidationErrorType.empty && (
          <div>
            <SectionDivider gap={4} />
            <FormValidationError>
              {masterServicesStrings.masterServiceDetailsContent.formFieldErrorText(
                masterServicesStrings.masterServiceDetailsContent.statusFieldLabel,
              )}
            </FormValidationError>
          </div>
        )}
      </FormFieldWrapper>
    </FormGrid>
  );
};
// ###############################################################
// <----------------------- End Return UI ----------------------->
// ###############################################################

AddOrEditMasterServiceComponent.propTypes = {
  formFieldsValues: PropTypes.shape({
    englishName: PropTypes.string,
    arabicName: PropTypes.string,
    categoryKey: PropTypes.string,
    status: PropTypes.string,
  }).isRequired,
  setFormFieldsValues: PropTypes.func.isRequired,
  formFieldsValidation: PropTypes.shape({
    englishName: PropTypes.number,
    arabicName: PropTypes.number,
    status: PropTypes.number,
  }).isRequired,
};

export default AddOrEditMasterServiceComponent;
